import { combineReducers } from "redux";
import {
  getStartActionName,
  getSuccessActionName,
} from "../../../core/make-action";
import ViewerMethod from "../../../core/ViewerMethod";
import { PageFit, PageLayout } from "./types";

function zoom(state = 1, action) {
  switch (action.type) {
    case getSuccessActionName(ViewerMethod.SET_ZOOM):
    case getSuccessActionName(ViewerMethod.ZOOM_IN):
    case getSuccessActionName(ViewerMethod.ZOOM_OUT):
    case getSuccessActionName(ViewerMethod.GET_ZOOM):
      return action.resultData.zoomScale;
    case getStartActionName(ViewerMethod.FIT_WIDTH):
    case getStartActionName(ViewerMethod.FIT_HEIGHT):
      return 1;
    default:
      return state;
  }
}

function pageFit(state = PageFit.WIDTH, action) {
  switch (action.type) {
    case getStartActionName(ViewerMethod.FIT_WIDTH):
      return PageFit.WIDTH;
    case getStartActionName(ViewerMethod.FIT_HEIGHT):
      return PageFit.HEIGHT;
    default:
      return state;
  }
}

function pageLayout(state = PageLayout.SINGLE, action) {
  switch (action.type) {
    case getStartActionName(ViewerMethod.SET_LAYOUT_MODE):
      return action.apiCallArgs[0];
    default:
      return state;
  }
}

export default combineReducers({
  zoom,
  pageFit,
  pageLayout,
});
